import { bootstrapApplication } from '@angular/platform-browser';
import { enableProdMode } from '@angular/core';
import { environment } from './environments/environment';
import { extendConfiguration } from './config';
import * as Sentry from '@sentry/browser';

extendConfiguration().then(() => {
  if (environment.production) {
    enableProdMode();
  }

  if (environment.sentry) {
    Sentry.init({
      dsn: environment.sentry || undefined,
      environment: environment.envName || undefined,
      release: environment.version,
    });
  }
  Promise.all([import('./app/app.component'), import('./app/app.config')]).then(
    ([{ AppComponent }, { appConfig }]) => {
      bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
    },
  );
});
